<template>
    <b-modal
        id="magazine-comment-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.save')"
        ok-variant="primary"
        size="md"
        @ok="onOk"
        :title="$t('magazine.add_comment')">
        <b-textarea v-model="comment"></b-textarea>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-magazine-yearbooks-comment-modal-component',
    data() {
        return {
            modal: false,
            magazine: null,
            comment: null,
        };
    },
    methods: {
        show(magazine) {
            this.magazine = magazine;
            this.comment = magazine.comment;
            this.modal = true;
        },
        onOk() {
            const data = {
                comment: this.comment,
                todo: this.magazine.todo,
                color: this.magazine.color,
            };
            this.axios.post(this.routes.magazineAdminValues(this.magazine.id), data).then(
                (response) => {
                    this.$emit('update-admin-values', { id: this.magazine.id, values: data });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
